













































import { CONFIG } from '@/config';
import { httpService } from '@/services';
import { AxiosError, AxiosResponse } from 'axios';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class WizardStoreConvert extends Vue {
  @Prop({ default: false }) open: boolean;
  @Prop({ required: true }) store: any;

  public canApplyPermanentChanges = 0;

  public storeTypeDataSource = [{
    text: '2S',
    value: 1
  }, {
    text: '3S',
    value: 2
  }];

  @Watch('open')
  public onOpen (openValue: boolean) {
    if (openValue) {
      if (this.store.idStoreTypeClient === 2) {
        httpService.http
          .get(`${CONFIG.URL.NEODASH_API}/api/dap/store/${this.store.idProject}/${this.store.idStoreMatrix}/CanPermanentChanges`)
          .then((res: AxiosResponse) => {
            this.canApplyPermanentChanges = res.data ? 1 : 2;
          })
          .catch((err: AxiosError) => console.log(err.message));
      } else {
        this.canApplyPermanentChanges = 1;
      }
    }
  }

  @Emit('submit')
  onSubmit () {} // tslint:disable-line

  @Emit('cancel')
  onCancel () {} // tslint:disable-line
}
